import axios, { AxiosResponse } from 'axios';
import { UpdateManualFeedsStatusInput } from '../types/update-manual-feeds-status.type';

// PUT
// Bulk manage feeds.
// ​/ewosapi​/v1​/feeds/manual/company/{globalCompanyId}/feed-activation-status
export const putManualFeedsStatus = async (globalCompanyId: string, request: UpdateManualFeedsStatusInput): Promise<AxiosResponse> => {
  const res = await axios.put<AxiosResponse>(
    `/ewosapi/v1/feeds/manual/company/${globalCompanyId}/feed-activation-status`,
    request
  );
  return res.data;
};
